import { Button, Dialog, Flex } from '@buffer-mono/popcorn'

import { ChannelRefreshCard } from './ChannelRefreshCard'
import type { RefreshableChannel } from './ChannelRefreshCard'

export type ReconnectChannelsDialogProps = {
  channels: RefreshableChannel[]
  open: boolean
  onOpenChange: (open: boolean) => void
}

/**
 * Lists the channels that need a refresh before Community can use them, each
 * with its own Refresh button. Opened from the All Channels refresh notice.
 */
export const ReconnectChannelsDialog = ({
  channels,
  open,
  onOpenChange,
}: ReconnectChannelsDialogProps): JSX.Element => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <Dialog.Content>
      <Dialog.Header>
        <Dialog.Title>Reconnect your channels</Dialog.Title>
        <Dialog.Description>
          Refresh the connections to start using Community.
        </Dialog.Description>
      </Dialog.Header>
      <Dialog.Body>
        <Flex direction="column" gap="sm" fullWidth>
          {channels.map((channel) => (
            <ChannelRefreshCard
              key={channel.id}
              channel={channel}
              cta="publish-comments-all-channels-dialog-refresh"
            />
          ))}
        </Flex>
      </Dialog.Body>
      <Dialog.Footer>
        <Dialog.Close>
          <Button variant="tertiary">Cancel</Button>
        </Dialog.Close>
      </Dialog.Footer>
    </Dialog.Content>
  </Dialog>
)

ReconnectChannelsDialog.displayName = 'ReconnectChannelsDialog'
